import React, { useMemo, useState } from "react";
import { RCCGrid } from "react-common-components";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import { useTranslation } from "src/context/Translations/context";
import Select from "../Select";
import palettes, { palettesOptions } from "./colors";
import { PaletteOptions } from "./interface";
import { colorsContainer, ColorSquare } from "./styles";

const PalettePicker: React.FC<Omit<IComponentSelect,"options">> = ({
	name,
	control,
	label,
	onChangeCapture,
	defaultValue,
	...rest
}) => {
	const { translate} = useTranslation();
	const [selectedColor,setSelectedColor] = useState<PaletteOptions>(defaultValue || "1");

	const onChangeHandler = (value:any) => {
		setSelectedColor(value.value);
		if(onChangeCapture)
		    onChangeCapture(value);
	};

	const PaletteColors = useMemo(() => {
        
		const selectedPalette = palettes.find((x) => x.idColor === selectedColor);
		return (
			selectedPalette?.colors.map((color) => (
				<ColorSquare key={`colorSquare-${color}`} color={color}/>
			))
		);
	},[selectedColor]);

	return (
		<RCCGrid container spacing={1}>
			<RCCGrid container item sm={4} >
				<Select
					control={control}
					name={name}
					label={label||translate("Paleta de cores")}
					defaultValue={selectedColor}
					options={palettesOptions}
					onChangeCapture = {onChangeHandler}
					{...rest}
				/>
			</RCCGrid>
			<RCCGrid container item sm={8} alignContent="flex-end" styleInline={colorsContainer}>
				{PaletteColors}
			</RCCGrid>
		</RCCGrid>
	);
};

export default PalettePicker;
